// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2fKfL","info":"UpdateTermsInfo_info__S6h-F"};